import React from 'react'


export const OnboardingCard = ({img_scr, h1_text, p_text, index, cardIndex, svg}) => {

  return (
    <div className='onboarding_card' style={index === cardIndex ? {opacity: 1} : {opacity: 0}}>
        <img src={img_scr} alt="" height={window.innerHeight - 300}/>
        <div className="onboarding_card_text">
            {svg ?
                <>

                    <h1>{h1_text.split(',')[0]},
                        <br/>
                        <span style={{display:'flex', alignItems:'center', justifyContent:'center', gap: 5}}>
                            on
                            {svg}
                            {h1_text.split(',')[1]}
                        </span>
                    </h1>
                    <p>{p_text}</p>
                </>
                :
                <>
                    <h1>{h1_text}</h1>
                    <p>{p_text}</p>
                </>
            }
        </div>
    </div>
  )
}
